import { useEffect, useState, useCallback } from 'react';

const useAsync = (callback, dependencies = []) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [value, setValue] = useState();

  const callbackMemoized = useCallback(() => {
    setLoading(true);
    setError(undefined);
    setValue(undefined);
    callback()
      .then(setValue)
      .catch(setError)
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  useEffect(() => {
    callbackMemoized();
  }, [callbackMemoized]);

  return { loading, error, value };
};

export const useScript = (url) => {
  return useAsync(() => {
    return new Promise((resolve, reject) => {
      // Check if the script already exists
      const existingScript = document.querySelector(`script[src="${url}"]`);

      if (existingScript) {
        // If the script is already loaded, resolve immediately
        if (existingScript.getAttribute('data-loaded') === 'true') {
          resolve();
        } else {
          // If the script is still loading, wait for it to load
          existingScript.addEventListener('load', resolve);
          existingScript.addEventListener('error', reject);
        }
      } else {
        // If the script doesn't exist, create and load it
        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        script.addEventListener('load', () => {
          script.setAttribute('data-loaded', 'true');
          resolve();
        });
        script.addEventListener('error', reject);
        document.body.appendChild(script);
      }
    });
  }, [url]);
};
